import {
  useCurrentRefinements,
  useRefinementList,
} from "react-instantsearch-hooks-web";
import * as DropdownMenu from "@radix-ui/react-dropdown-menu";
import { AiFillCheckCircle } from "react-icons/ai";
import { FiCircle } from "react-icons/fi";
import { IoMdArrowDropdown } from "react-icons/io";
function PropertyTypeRefinement({ param }) {
  const {
    items,
    hasExhaustiveItems,
    createURL,
    refine,
    sendEvent,
    searchForItems,
    isFromSearch,
    canRefine,
    canToggleShowMore,
    isShowingMore,
    toggleShowMore,
  } = useRefinementList({ attribute: "propertyType" });
  const props = useCurrentRefinements();
  //console.log(props.items, props.canRefine, props.createURL)
  const itemRefs = props.items;
  const arr = itemRefs.find((c) => c.attribute === "propertyType");

  // console.log(items)

  return (
    <>
      <DropdownMenu.Root>
        <DropdownMenu.Trigger asChild>
          <button className=" flex flex-shrink-0 cursor-pointer select-none flex-row items-center rounded border border-gray-400 bg-white px-4 py-2 text-sm capitalize text-gray-900 lg:space-x-1 lg:px-5 lg:py-3">
            <span className=" flex lg:hidden">
              {" "}
              {arr && arr?.refinements.length != 0
                ? `Type (${arr?.refinements.length})`
                : "Type"}
            </span>
            <span className=" hidden lg:flex">
              {" "}
              {arr && arr?.refinements.length != 0
                ? `Home Type (${arr?.refinements.length})`
                : "Home Type"}
            </span>

            <IoMdArrowDropdown className="  h-5 w-5 text-gray-700" />
          </button>
        </DropdownMenu.Trigger>
        <DropdownMenu.Portal>
          <DropdownMenu.Content
            sideOffset={2}
            className=" z-20 flex h-auto w-auto  flex-col rounded-md border border-gray-300 bg-white pb-8 pl-8 pr-12 pt-5 shadow-md"
          >
            <DropdownMenu.Label className=" select-none text-sm text-gray-600">
              <span className=" flex lg:hidden">Type</span>
              <span className=" hidden lg:flex">Home Type</span>
            </DropdownMenu.Label>
            <DropdownMenu.Group className="mt-2 flex flex-col space-y-4">
              {items?.map((item) => {
                const exists = arr?.refinements.find(
                  (el) => el.value === item.value
                )?.value;
                return (
                  <DropdownMenu.CheckboxItem
                    checked={exists}
                    onSelect={(e) => {
                      e.preventDefault();
                      refine(item.value);
                    }}
                    key={item.value}
                    className=" flex flex-row items-center space-x-2 outline-none"
                  >
                    <DropdownMenu.ItemIndicator forceMount>
                      {exists ? (
                        <AiFillCheckCircle className="h-5 w-5 text-ula-primary" />
                      ) : (
                        <FiCircle className="h-5 w-5 text-gray-600" />
                      )}
                    </DropdownMenu.ItemIndicator>
                    <span className=" cursor-pointer select-none text-base text-gray-800   hover:text-gray-900">
                      {item.label}
                    </span>
                  </DropdownMenu.CheckboxItem>
                );
              })}
            </DropdownMenu.Group>
            <DropdownMenu.Arrow
              className="  fill-gray-200"
              width={10}
              height={5}
            />
          </DropdownMenu.Content>
        </DropdownMenu.Portal>
      </DropdownMenu.Root>
    </>
  );
}

export default PropertyTypeRefinement;
